import React, { useState,useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { countyurl } from "../../../apis/urls";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditCounty = () => {

    const { id } = useParams();

    useEffect(() => {
        editlisting();
    },[]
    );

    const [res,setRes] = useState([]);
    const [name,setName] = useState('');
    const [description, setDescription] = useState('');
    const [status, setStatus] = useState('');
    const [nameerror,setNameerror] = useState(false);
    const[alertText, setAlertText]=useState("");
    const[added, setAdded]=useState(false);


    useEffect(() => {

        if(added == true){

            const notify = () => toast.success("Updated Successfully!..", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 1500
              });

              notify();
        }
      }, [added])


    let navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/county_list")
        
    }


    const editlisting = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: countyurl+id,

            timeout: 1000000,

            headers: {'authorization': token}

            });
            
            instance.get('').then((response) =>{
            
            setRes(response.data.data);
            //console.log(response.data.data.name)
            //console.log("name",res.name)
            setName(response.data.data.name);
            setDescription(response.data.data.description);
            setStatus(response.data.data.status);

           
            
            }).catch((error) =>{
            
            console.log('error',error.message)
            

            });
    }

    const onEditForm = () => {

        setAdded(true);

        let error = 0;

        if(name === '')
        {
            setNameerror(true)
            error =1;
        }
        

        if(error === 0) 
        {

            let token = "Bearer "+localStorage.getItem('token');
        
            const data = {
                name :name,
                description :description,
                status :status
            }
            
            const instance = axios.create({

                baseURL: countyurl+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.put('',data).then((response) =>{
                
                setTimeout(() => {

                    navigate("/county_list")

                }, 1500); 

                setAlertText("County Updated");
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            
                

            });

        }

        
    }


    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Edit County</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/county_list">County</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Edit County</li>
                        </ol>
                    </nav>

                    <form className="needs-validation" noValidate>
                        <div className="form-wrpr">
                            <div class="card formcard small">
                                <div class="card-body">
                                    <div class="form-group">
                                        <label className="degreehead">Name <span style={{color: "red"}}>*</span></label>
                                        <input type="text" class="form-control bg-dark dark-theme showtext" onChange={e => {setName(e.target.value)}} defaultValue={res.name} id="name"></input>
                                        {
                                        nameerror
                                        ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Name</div>
                                        :null
                                        }
                                    </div>
                                    <div class="form-group">
                                        <label className="degreehead">Description</label>
                                        <input type="text" class="form-control bg-dark dark-theme showtext" onChange={e => {setDescription(e.target.value)}}  defaultValue={res.description} id="name"></input>
                                    </div>
                                    <div className="form-group">
                                        <label className="degreehead">Status <span style={{color: "red"}}>*</span></label>
                                        <select className="form-control bg-dark dark-theme showtext" onChange={e => {setStatus(e.target.value)}} id="status-selector">
                                        <option value="ACTIVE">Select Status</option>
                                        <option value="ACTIVE" selected = {res.status === 'ACTIVE'}>ACTIVE</option>
                                        <option value="INACTIVE" selected = {res.status === 'INACTIVE'}>INACTIVE</option>
                                        <option value="DELETED" selected = {res.status === 'DELETED'}>DELETED</option>
                                        </select>                        
                                    </div>
                                    <h6 style={{color: "red"}}>* Required Fields</h6>
                                    
                                    <div class="form-group text-right">
                                        <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                        <button onClick={onEditForm} className="btn btn-primary btn-gisa" type="button">Update</button>
                                    </div>
                                    <div>
                                    {/* <button onClick={notify}>Notify !</button> */}
                                    <ToastContainer
                                        style={{width: 578, marginTop: '10%', marginLeft: '8.3%'}}
                                        toastStyle={{backgroundColor: "#f1c40f", color: 'white', fontSize: 16}}
                                        progressStyle={{backgroundColor: 'white'}}
                                        
                                    />
                                </div>
                                </div>
                            </div>
                            
                        </div>
                    </form>


                </div>
            </aside>
        </div>
    )
}

export default EditCounty;